import { Button } from '@mui/material';
import { alpha, darken, useTheme } from '@mui/material/styles';
import { route } from 'src/components/common/router/Router';
import { getCustomOrDefaultText, useLocale } from '@repo/i18n';
import { capitalize } from '@repo/common-utils/TextUtils';
import { useCustomizations } from 'src/components/utils/theme/customizations';
import { getBookingButtonSizeStyle } from 'src/components/utils/theme/bookingButtonSizeStyle';
import { useConfigurations } from '@repo/widget-utils/widgetsConfiguration';
import { UserTextCustomizations } from '@repo/types';

import type { JSX } from 'react';

export default function CreateGiftcard(props: {
    size: 's' | 'm' | 'l';
    xsSize: 's' | 'm' | 'l';
    buttonTextCustomizationKey?: keyof UserTextCustomizations;
}): JSX.Element {
    const { t, locale } = useLocale();
    const customizations = useCustomizations();
    const theme = useTheme();
    const configurations = useConfigurations();
    const handleBookNowClicked = () => {
        route('/gift-card-checkout');
    };
    const handleBookNowEnter = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            route('/gift-card-checkout');
        }
    };
    return (
        <Button
            variant={customizations.primaryButtonStyle}
            color="primary"
            onKeyDown={handleBookNowEnter}
            onMouseDown={handleBookNowClicked}
            sx={{
                color: customizations.bookingButtonTextColor,
                backgroundColor:
                    customizations.bookingButtonStyle === 'contained'
                        ? customizations.bookingButtonColor
                        : 'transparent',
                borderColor:
                    customizations.bookingButtonStyle === 'contained'
                        ? 'transparent'
                        : customizations.bookingButtonTextColor,
                ...getBookingButtonSizeStyle(props.size, props.xsSize, theme, customizations),
                boxShadow:
                    customizations.bookingButtonStyle === 'contained'
                        ? theme.shadows[1]
                        : undefined,
                '&:hover, &:focus, &:active': {
                    boxShadow:
                        customizations.bookingButtonStyle === 'contained'
                            ? theme.shadows[3]
                            : undefined,
                    color: customizations.bookingButtonTextColor,
                    borderColor:
                        customizations.bookingButtonStyle === 'contained'
                            ? 'transparent'
                            : customizations.bookingButtonTextColor,
                    backgroundColor:
                        customizations.bookingButtonStyle === 'contained'
                            ? darken(customizations.bookingButtonColor, 0.2)
                            : alpha(customizations.bookingButtonTextColor, 0.3),
                },
            }}
            aria-label={t.aria_book_now_button}
        >
            {capitalize(
                getCustomOrDefaultText(
                    configurations.textCustomizations,
                    props.buttonTextCustomizationKey,
                    locale,
                    t.create_your_gift,
                ),
            )}
        </Button>
    );
}
